import capitalizeFirst from "./capitalizeFirst"
import capitalizeFirstSelect from "./capitalizeFirstSelect"

export default {
  install(Vue) {
    Vue.directive("capitalize-first", capitalizeFirst)
    Vue.directive("capitalize-first-select", capitalizeFirstSelect)
  }
}
